import React, { useMemo, useState } from "react";
import MyRouter from "routers/index";
import { requestAPI } from "utils/api";


function App() {
	
	return (
	<div className="text-base bg-slate-50 dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
		<MyRouter />
	</div>
	);
}

export default App;
